import React, { forwardRef, useRef } from 'react';
import cn from 'classnames';

import useRedactor from './useRedactor';

import { TESTING_ID as TEXT_EDITOR_TESTING_ID } from './constants';

export {
  VARIANTS as TEXT_EDITOR_VARIANTS,
  TESTING_ID as TEXT_EDITOR_TESTING_ID,
} from './constants';

function TextEditor({ forwardedRef, ...props }) {
  const {
    id,
    containerClassName,
    className,
    defaultValue,
    disabled,
    isDragging,
  } = props;
  const ref = useRef(null);
  useRedactor(ref || forwardedRef, props);

  const containerClasses = cn('llui-text-editor', containerClassName, {
    'no-fixed': disabled || isDragging,
    'is-disabled': disabled,
  });

  return (
    <div className={containerClasses} data-test-id={TEXT_EDITOR_TESTING_ID}>
      <textarea
        id={id}
        className={className}
        ref={ref || forwardedRef}
        defaultValue={defaultValue}
        disabled={disabled}
      />
    </div>
  );
}

export default forwardRef((props, ref) => (
  <TextEditor {...props} forwardedRef={ref} />
));
